module.exports = __webpack_public_path__ + "static/media/porque-fullm.85526385.png";